import React, {createContext, type ReactNode, useState} from 'react';

import {v4} from 'uuid';

import type {LeftSidebarElementType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {StickySidebarElementType} from 'app/components/general/DetailPage/RightSidebar/structure/types';
import type {
  CurrentItemType,
  DetailPageItemType,
} from 'app/components/general/DetailPage/types';

interface DetailPageContextType {
  fullscreenWidget:
    | null
    | StickySidebarElementType<CurrentItemType<DetailPageItemType>>
    | LeftSidebarElementType<CurrentItemType<DetailPageItemType>>;
  setFullscreenWidget: (
    newFullscreenWidget:
      | null
      | StickySidebarElementType<CurrentItemType<DetailPageItemType>>
      | LeftSidebarElementType<CurrentItemType<DetailPageItemType>>
  ) => void;
  sweetAIConversationId: string;
  setSweetAIConversationId: (string) => void;
}

export const DetailPageContext = createContext<
  DetailPageContextType | undefined
>(undefined);

export function DetailPageContextProvider<ItemType extends DetailPageItemType>({
  children,
  threadId,
}: {
  children: ReactNode;
  threadId?: string;
}) {
  const [fullscreenWidget, setFullscreenWidget] = useState<
    null | StickySidebarElementType<ItemType> | LeftSidebarElementType<ItemType>
  >(null);

  const [sweetAIConversationId, setSweetAIConversationId] = useState(
    threadId ?? v4()
  );

  return (
    <DetailPageContext.Provider
      value={{
        fullscreenWidget,
        setFullscreenWidget,
        sweetAIConversationId,
        setSweetAIConversationId,
      }}
    >
      {children}
    </DetailPageContext.Provider>
  );
}
